import { Page } from '@dixa/lib-shared-habla';

import { uploadsApi } from 'apis/uploads';

import { Table } from '../table/table';

export const AudioMessageFiles = (): JSX.Element => {
  const { data, refetch, isLoading, isError } =
    uploadsApi.useReadAnnouncementsQuery();

  const numFiles = data?.data.uploads.length;

  return (
    <Page.Section
      title={`${numFiles ?? 0} audio message${numFiles === 1 ? '' : 's'}`}
    >
      <Table
        type="announcement"
        data={data}
        retry={refetch}
        isLoading={isLoading}
        isError={isError}
      />
    </Page.Section>
  );
};
